document.addEventListener("DOMContentLoaded", function () {
	const accordions = document.querySelectorAll(".mr-accordion");

	accordions.forEach((accordion) => {
		const items = accordion.querySelectorAll(".mr-accordion-item");
		const isAlwaysOpen = accordion.dataset.alwaysOpen === "true";

		items.forEach((item, index) => {
			const header = item.querySelector(".mr-accordion-item__header");
			const panel = item.querySelector(".mr-accordion-item__panel");
			const icon = header.querySelector(".mr-accordion-item__icon");

			header.addEventListener("click", function () {
				const isActive = item.classList.contains("is-active");

				if (!isAlwaysOpen) {
					// Close all other items first
					items.forEach((otherItem) => {
						if (otherItem !== item) {
							otherItem.classList.remove("is-active");
							const otherPanel = otherItem.querySelector(
								".mr-accordion-item__panel",
							);
							const otherIcon = otherItem.querySelector(
								".mr-accordion-item__icon",
							);
							const otherHeader = otherItem.querySelector(
								".mr-accordion-item__header",
							);

							if (otherPanel) {
								otherPanel.classList.remove("is-active");
								otherPanel.style.maxHeight = "0";
							}
							if (otherIcon) {
								otherIcon.classList.remove("is-active");
							}
							if (otherHeader) {
								otherHeader.classList.remove("is-active");
							}
						}
					});
				}

				// Toggle current item
				if (isActive) {
					item.classList.remove("is-active");
					if (panel) {
						panel.classList.remove("is-active");
						panel.style.maxHeight = "0";
					}
					if (icon) {
						icon.classList.remove("is-active");
					}
					header.classList.remove("is-active");
				} else {
					item.classList.add("is-active");
					if (panel) {
						panel.classList.add("is-active");
						panel.style.maxHeight = panel.scrollHeight + "px";
					}
					if (icon) {
						icon.classList.add("is-active");
					}
					header.classList.add("is-active");
				}
			});
		});

		// Initialize first item as open if specified
		const firstItem = items[0];
		if (firstItem && firstItem.dataset.initialOpen === "true") {
			firstItem.classList.add("is-active");
			const panel = firstItem.querySelector(".mr-accordion-item__panel");
			const icon = firstItem.querySelector(".mr-accordion-item__icon");
			const header = firstItem.querySelector(".mr-accordion-item__header");

			if (panel) {
				panel.classList.add("is-active");
				panel.style.maxHeight = panel.scrollHeight + "px";
			}
			if (icon) {
				icon.classList.add("is-active");
			}
			if (header) {
				header.classList.add("is-active");
			}
		}
	});
});
